import { Component } from '@angular/core';
import { ModalService } from 'src/app/services/modal.service';

const FIRST_INDEX = 0;

@Component({
  selector: 'app-high-risk',
  templateUrl: './high-risk.component.html',
  styleUrls: ['./high-risk.component.scss'],
})
export class HighRiskComponent {
  currentIndex = FIRST_INDEX;

  constructor(private modalService: ModalService) {}

  closeModal() {
    this.modalService.closeModalAll();
  }
}
